import NextLink from 'next/link';

import { LinkBox, LinkOverlay, Text } from '@chakra-ui/react';

import { TypeArea, TypeJobAdvert } from 'generated/contentful';

import { RECRUIT_PATH_PREFIX } from 'common/constants';

interface SimilarJobProps {
  job: TypeJobAdvert<'WITHOUT_UNRESOLVABLE_LINKS', string>;
  area: TypeArea<'WITHOUT_UNRESOLVABLE_LINKS', string>;
}

export default function SimilarJob({ job, area }: SimilarJobProps) {
  const displayRate =
    job.fields.minimumPay === job.fields.maximumPay
      ? `£${job.fields.minimumPay.toFixed(2)}`
      : `£${job.fields.minimumPay.toFixed(2)} - £${job.fields.maximumPay.toFixed(2)}`;

  return (
    <LinkBox borderRadius="md" borderWidth={1} borderColor="gray.100" bg="gray.50" p={5} mb={4}>
      <Text fontWeight="medium">
        <LinkOverlay
          as={NextLink}
          href={`${RECRUIT_PATH_PREFIX}/jobs/${area.fields.city?.fields.slug}/${area.fields.slug}/${job.fields.slug}/`}
          title={`${job.fields.title} in ${area.fields.name} - ${job.fields.employmentType.join(' or ')}`}
        >
          {job.fields.title} - {job.fields.employmentType.join(' or ')}
        </LinkOverlay>
      </Text>
      <Text>{area.fields.name}</Text>
      <Text>
        {displayRate} Per {job.fields.payFrequency}
      </Text>
    </LinkBox>
  );
}
